import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Access from "./components/Access";
import WebApp from "./components/WebApp";
import Download from "./components/Download";
import Popular from "./components/Popular";
import Faq from "./components/Faq";
import About from "./components/About";
import Footer from "./components/Footer";

const schemaJsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "动漫之家官网入口导航站",
    description:
      "动漫之家官网地址更新，网页版与APP下载入口直达，帮助用户快速回到追番页面。",
    url: "https://sgcrc53.cn/",
    inLanguage: "zh-CN",
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "动漫之家",
    url: "https://sgcrc53.cn/",
    logo: "https://sgcrc53.cn/vite.svg",
    contactPoint: {
      "@type": "ContactPoint",
      email: "support@dongmanzhijia.example.com",
      contactType: "customer service",
      availableLanguage: "Chinese",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "动漫之家打不开怎么办？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "动漫之家偶尔会因为网络波动或访问高峰暂时无法打开。建议先刷新页面、更换浏览器或切换网络（移动数据与 WiFi 互切），再尝试从本页的网页版入口进入。",
        },
      },
      {
        "@type": "Question",
        name: "动漫之家换网址了，如何找到新站？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "动漫之家地址更新后，请以本页「访问入口」栏公布的最新官网地址为准，点击「进入网页版」即可直达最新可用网址，收藏本页可随时回来获取更新。",
        },
      },
      {
        "@type": "Question",
        name: "网页版和 APP 有什么区别？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "网页版无需安装、浏览器即开即用，适合电脑大屏追番；APP 支持离线缓存、弹幕互动和追更提醒，适合随时随地使用。两者内容同步，账号收藏与观看进度互通。",
        },
      },
    ],
  },
];

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaJsonLd) }}
      />
      <Navbar />
      <main>
        <Hero />
        <Access />
        <WebApp />
        <Download />
        <Popular />
        <Faq />
        <About />
      </main>
      <Footer />
    </>
  );
}